import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from 'react-router';

import VoiceTrackIcon from '../../../../static/icons/ic_voicetrack_16.svg';
import { BackstageContentSections } from '../../../constants/ContentSections';
import QA from '../../../constants/QATags';
import { AppContext } from '../../../lib/Context';
import { createBEM } from '../../../lib/utils/css';
import Icon from '../../Icon/Icon';
import { withVisibilityLogger } from '../../VisibilityLogger/VisibilityLogger';
import Badge from '../Badge/Badge';
import EditableTitleT3 from '../EditableTitleT3/EditableTitleT3';

import './HeaderBackstage.scss';

export const HeaderBackstageStyles = {
  SUBTITLE_LINK: 'HeaderBackstage__text__subTitle__link',
};

export class HeaderBackstage extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    titleUrl: PropTypes.string,
    badges: ImmutablePropTypes.listOf(PropTypes.string),
    subTitleLrg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subTitleSm: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    editableOnUpdate: PropTypes.func,
    isEditable: PropTypes.bool,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    titleValidator: PropTypes.func,
    disableHover: PropTypes.bool,
    editableOnSave: PropTypes.func,
    editableOnFocus: PropTypes.func,
    isHosted: PropTypes.bool,
    isHeaderInSidebar: PropTypes.bool,
  };

  static contextType = AppContext;

  onTitleLinkClick = e => {
    this.context.integration.action.clicked({
      contentSection: BackstageContentSections.HEADER,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  renderBadges = () => {
    if (!this.props.badges) {
      return;
    }

    return this.props.badges.map((badgeType, index) => {
      return (
        <div className='HeaderBackstage__text__titleBadge' key={index}>
          <Badge badgeType={badgeType} />
        </div>
      );
    });
  };

  renderTitle = () => {
    const { titleUrl, title, isEditable } = this.props;
    const className = createBEM('HeaderBackstage__text__title', {
      hosted: this.props.isHosted,
    });
    const qaTag = QA.HSTT;
    const icon = this.props.isHosted ? <Icon glyph={VoiceTrackIcon} /> : null;
    if (isEditable) {
      return (
        <span className={className} data-qa={qaTag}>
          {icon}
          <EditableTitleT3
            title={title}
            maxLength={this.props.maxLength}
            placeholder={this.props.placeholder}
            titleValidator={this.props.titleValidator}
            onUpdate={this.props.editableOnUpdate}
            isEditable={isEditable}
            onSave={this.props.editableOnSave}
            onFocus={this.props.editableOnFocus}
            qaTag={QA.BSET}
          />
        </span>
      );
    }
    if (titleUrl) {
      return (
        <Link
          to={titleUrl}
          onClick={this.onTitleLinkClick}
          className={`${className} ${className}--link`}
          data-qa={qaTag}
        >
          {icon}
          {title}
        </Link>
      );
    }
    return (
      <span className={className} data-qa={qaTag}>
        {icon}
        {title}
      </span>
    );
  };

  render() {
    const classes = createBEM('HeaderBackstage', {
      disableHover: this.props.disableHover,
      topHeader: !this.props.isHeaderInSidebar,
      sidebarHeader: this.props.isHeaderInSidebar,
    });
    return (
      <div className={classes} data-qa={QA.BSH}>
        <h1 className='HeaderBackstage__text'>
          {this.renderTitle()}
          {this.renderBadges()}
          {this.props.subTitleLrg && (
            <span className='HeaderBackstage__text__subTitle HeaderBackstage__text__subTitle--lrg'>
              {this.props.subTitleLrg}
            </span>
          )}
          {this.props.subTitleSm && (
            <span className='HeaderBackstage__text__subTitle HeaderBackstage__text__subTitle--sm'>
              {this.props.subTitleSm}
            </span>
          )}
        </h1>
      </div>
    );
  }
}

export const HeaderBackstageWithLogger = withVisibilityLogger({
  contentSection: BackstageContentSections.HEADER,
})(HeaderBackstage);

export default HeaderBackstage;
